import {ref, reactive, computed, watch, watchEffect} from 'vue';

const booklistState = reactive({
    filteredSubjectCode:"",
    filteredTypeCode:"",
    searchText:"",
    viewMode:"thumb"
});

export function useBookList() {

    const getEbookCoverURL = (ebookcoverurl, ebookcode)=> {

       //TODO: test for production
        /*
        if (process.env.VUE_APP_ENV === 'release') {
            ebookcoverurl = ebookcoverurl.replace(process.env.VUE_APP_LINK_EBOOK_DOWNLOAD, process.env.VUE_APP_DOMAIN_HK_EXT_FILESERVER);
        }

         */
        ebookcoverurl = `${ebookcoverurl}&access_token=${localStorage.accessToken}`;
        return ebookcoverurl;

    }

    /**
     * Determine if the thumbnail should show, according to search text and filter dropdown
     */
    const isShowBookEntry = (book)=>{

        if (booklistState.searchText.indexOf("|") >=0 ) {
            return false;
        }

        let isShow = false;
        let modulenames =  book.ebooks.map(el=>{return el.ebookmodulename}).join("|").toLowerCase();
        //let author = book.ebooks.map(el=>{return el.author}).join("|").toLowerCase();
        let searchText = replaceDelimiterInSearchText();

        if ((booklistState.filteredSubjectCode === book.subjectcode || booklistState.filteredSubjectCode === "") &&
            (booklistState.filteredTypeCode === book.ebooktypecode || booklistState.filteredTypeCode === "")  &&
            (modulenames.indexOf(searchText)>=0 ||
                book.ebookseriesname.toLowerCase().indexOf(searchText)>=0 ||
                //author.indexOf(searchText)>=0 ||
                book.ebookname.toLowerCase().indexOf(searchText)>=0 ||
                searchText=== ""
            )
        ) {
            isShow = true;
        }

        return isShow;

    }

    /**
     * Determine if the module should show, according to search text and filter dropdown
     */
    const isShowModule = (book, modulename) => {

        if (booklistState.searchText.indexOf("|") >=0 ) {
            return false;
        }

        let searchText = replaceDelimiterInSearchText();
        //let author = book.ebooks.map(el=>{return el.author}).join("|").toLowerCase();

        return (
            modulename.toLowerCase().indexOf(searchText)>=0 ||
            book.ebookname.toLowerCase().indexOf(searchText)>=0 ||
            //author.indexOf(searchText)>=0 ||
            book.ebookseriesname.toLowerCase().indexOf(searchText)>=0 ||
            searchText === ""
        );
    }

    /**
     * replace the search string delimiter (which is |) by empty string, so that exact target value of the entry can be matched
     */
    const replaceDelimiterInSearchText = ()=>{
        return  booklistState.searchText.trim().toLocaleLowerCase().replace("|", "");
    }

    /**
     * reset set state to default value;
     */
    const reset = ()=>{
        console.log("reset @booklist.js")
        booklistState.filteredSubjectCode = "";
        booklistState.filteredTypeCode = "";
        booklistState.searchText = "";
        booklistState.viewMode = "thumb";

    }

    return {
        booklistState,
        getEbookCoverURL,
        isShowModule,
        isShowBookEntry,
        reset
    }

}

